import React from 'react'
import { ICONS } from '@Const/common'

interface WritersSectionProps {
    writers: string[]
}

const WritersSection = (props: WritersSectionProps) => {
    const { writers } = props
    return (
        <>
            <div className="section-header">
                <img src={ICONS.recordingWriters} alt="Recording Writers" />
                <h5>Writers</h5>
            </div>
            <div className="details writers-details">
                <div className="vertical-detail">
                    <p className="underline writer-label">Writer Name</p>
                    {writers.length === 0 ? (
                        <p className="not-available">Not Available</p>
                    ) : (
                        writers.map((writer: string, idx: number) => (
                            <p className="semi-bold" key={idx}>
                                {writer}
                            </p>
                        ))
                    )}
                </div>
            </div>
        </>
    )
}
export default WritersSection
